import { render, staticRenderFns } from "./ItemHistoricHeader.vue?vue&type=template&id=2fb24a58"
import script from "./ItemHistoricHeader.vue?vue&type=script&lang=js"
export * from "./ItemHistoricHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports